import { formatDate } from '../format/formatDate'
import { typeEmpty } from '../type/typeEmpty'
/**
 * @desc 验证是否date格式
 * @param {Boolean} required
 * @param {String} validateValue
 * @param {*} callback
 * @param {String} [field]
 * @param {String} [action]
 */
export const vDate = (required: boolean, validateValue: string, callback: any, field: string = '日期', action: string = '填写'): void => {
  if (!required && !validateValue) {
    callback()
  } else {
    if (typeEmpty(validateValue)) {
      action = action || '填写'
      callback(new Error(`${field}必须${action}`))
    } else {
      if (formatDate(validateValue)) {
        callback()
      } else {
        callback(new Error(`${field}格式不正确`))
      }
    }
  }
}
